/**
 * Auth helper for node executors.
 * Provides JWT token headers for fetch() calls.
 * Separated from index.js to avoid circular imports.
 */

export function getAuthHeaders(extraHeaders = {}) {
  const token = localStorage.getItem('modernizeit_token')
  const headers = { ...extraHeaders }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  return headers
}

/**
 * Parse a non-ok fetch() response into a clean Error and throw it.
 *
 * • 401 — clears session, dispatches auth-logout so the app redirects to login,
 *          throws a human-readable "session expired" message.
 * • Other 4xx/5xx — extracts detail/error/message from JSON body if possible,
 *                   falls back to a terse status description.
 *
 * Always throws. Call as: `if (!response.ok) await handleApiError(response)`
 *
 * @param {Response} response - The fetch Response that was not ok
 * @throws {Error} Always throws with a user-friendly message
 */
export async function handleApiError(response) {
  if (response.status === 401) {
    localStorage.removeItem('modernizeit_token')
    localStorage.removeItem('modernizeit_user')
    window.dispatchEvent(new CustomEvent('auth-logout', { detail: { reason: 'token_expired' } }))
    const err = new Error('Your session has expired — please log in again.')
    err.isAuthError = true
    throw err
  }

  let message
  try {
    const body = await response.json()
    message = body.detail || body.error || body.message || null
  } catch {
    // Body wasn't JSON — use status text
  }

  throw new Error(message || `Request failed (${response.status} ${response.statusText || ''})`.trim())
}
